/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import LinkButton from 'flarum/common/components/LinkButton';
import icon from 'flarum/common/helpers/icon';
import type Mithril from 'mithril';
import CreateBookshelfBtn from './CreateBookshelfBtn';
import type Bookshelf from '../../common/models/Bookshelf';

export interface BookshelvesHeroAttrs extends ComponentAttrs {
	isOwn?: boolean;
	onCreated: (bookshelf: Bookshelf) => void;
}

export default class BookshelvesHero<CustomAttrs extends BookshelvesHeroAttrs = BookshelvesHeroAttrs> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { isOwn, onCreated } = this.attrs;

		return (
			<div className="BookshelvesHero Hero IndexPageHero">
				<div className="container">
					<div className="containerNarrow">
						<h1 className="Hero-title">
							{icon('far fa-books')}
							{app.translator.trans(
								isOwn ? 'glowingblue-orell-bookshelf.forum.bookshelves.own_title' : 'glowingblue-orell-bookshelf.forum.bookshelves.title'
							)}
						</h1>
						<div className="IndexPageHero-controls">
							{!isOwn && app.session.user && (
								<LinkButton
									icon="far fa-books"
									className="Button Button--primary IndexPage-newDiscussion MyBookshelvesLink"
									itemClassName="App-primaryControl"
									href={app.route.book_collections()}
								>
									{app.translator.trans('glowingblue-orell-bookshelf.forum.bookshelves.own_title')}
								</LinkButton>
							)}
							<CreateBookshelfBtn onCreated={onCreated} />
						</div>
						<p className="Hero-description">{app.translator.trans('glowingblue-orell-bookshelf.forum.intro.bookshelves')}</p>
					</div>
				</div>
			</div>
		);
	}
}
